import {GoalQuestionnaireDefinition} from './goal/goalQuestionnaire'

export {GoalQuestionnaireDefinition}
